




import { Component, Prop, Vue } from 'vue-property-decorator';
import * as $ from 'jquery';
import DataTableNet from 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';
import '../../public/uikitjs/DataTablesExtJS';
const namespace: string = 'counter';
import { Action, Getter } from 'vuex-class';
import BaseView from '../BaseView';
import Common from '../helper/Common';
import AudienceAssociatedCampaignsGrid from '@/components/AudienceAssociatedCampaignsGrid.vue';

@Component({
    components: {
        AudienceAssociatedCampaignsGrid
    }
})
export default class AudienceAssociatedCampaigns extends BaseView {

    @Prop({ default: 0 })
    public AudienceId!: number;


    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private isListInitialized: boolean = false;

    private mounted() {
    }
}
